import React, { Component } from "react";
import ReactGA from "react-ga";
import hoistNonReactStatic from "hoist-non-react-statics";

export default function withTracker(WrappedComponent, options = {}) {
	const trackPage = page => {
		ReactGA.set({
			page,
			...options
		});
		// console.log(page);
		ReactGA.pageview(page);
	};

	const HOC = class extends Component {
		componentDidMount() {
			if (!ReactGA.ga.length) return;

			const page = this.props.location.pathname;
			trackPage(page);
		}

		componentWillReceiveProps(nextProps) {
			if (!ReactGA.ga.length) return;

			const currentPage = this.props.location.pathname;
			const nextPage = nextProps.location.pathname;

			if (currentPage !== nextPage) {
				trackPage(nextPage);
			}
		}

		render() {
			return <WrappedComponent {...this.props} />;
		}
	};

	hoistNonReactStatic(HOC, WrappedComponent);

	return HOC;
}



// WEBPACK FOOTER //
// ./src/components/GARouteWrapper.js